import { EntityModel } from '@/interfaces'
import {
  ALL_ACCOMMODATIONS_QUERY,
  CREATE_ACCOMMODATION_MUTATION,
  DELETE_ACCOMMODATION_MUTATION,
  FORCE_DELETE_ACCOMMODATION_MUTATION,
  SINGLE_ACCOMMODATION_QUERY,
  UPDATE_ACCOMMODATION_MUTATION,
} from './graphql'
import accommodationRoomTypeEntity from '@/entities/accommodationRoomType/entity'
import accommodationAvailableAddonEntity from '@/entities/accommodationAvailableAddon/entity'
import imageGalleryEntity from '@/entities/imageGallery/entity'

const accommodationModel: EntityModel = {
  name: 'accommodation',
  namePlural: 'accommodations',
  uniqueName: 'accommodation',
  uniqueNamePlural: 'accommodations',
  path: 'travel/accommodation/accommodation',
  baseUrl: '/travel/accommodations',
  translationPrefix: 'entities:accommodation.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_ACCOMMODATIONS_QUERY,
    getSingle: SINGLE_ACCOMMODATION_QUERY,
    create: CREATE_ACCOMMODATION_MUTATION,
    update: UPDATE_ACCOMMODATION_MUTATION,
    delete: DELETE_ACCOMMODATION_MUTATION,
    forceDelete: FORCE_DELETE_ACCOMMODATION_MUTATION,
  },
  attributes: {
    label: {
      name: 'label',
      label: 'entities:accommodation.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:accommodation.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    stars: {
      name: 'stars',
      label: 'entities:accommodation.attributes.stars.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:accommodation.attributes.stars.selectOptions.0.label',
          value: '0',
        },
        {
          label: 'entities:accommodation.attributes.stars.selectOptions.1.label',
          value: '1',
        },
        {
          label: 'entities:accommodation.attributes.stars.selectOptions.2.label',
          value: '2',
        },
        {
          label: 'entities:accommodation.attributes.stars.selectOptions.3.label',
          value: '3',
        },
        {
          label: 'entities:accommodation.attributes.stars.selectOptions.4.label',
          value: '4',
        },
        {
          label: 'entities:accommodation.attributes.stars.selectOptions.5.label',
          value: '5',
        },
      ],
      validationType: 'string',
      validations: [],
    },
    description: {
      name: 'description',
      label: 'entities:accommodation.attributes.description.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    roomTypes: {
      name: 'roomTypes',
      label: 'entities:accommodation.attributes.roomTypes.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return accommodationRoomTypeEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    availableAddons: {
      name: 'availableAddons',
      label: 'entities:accommodation.attributes.availableAddons.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return accommodationAvailableAddonEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    gallery: {
      name: 'gallery',
      label: 'entities:accommodation.attributes.gallery.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return imageGalleryEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default accommodationModel
